import { forwardRef } from "react";
import "./OTPInput.css";

/**
 * OTPInput
 * Single-field one-time code input that plays nicely with iOS / Android
 * SMS autofill ("one-time-code" autocomplete hint).
 *
 * Props:
 *  - value      : string of digits
 *  - onChange   : (digits) => void
 *  - onComplete : (digits) => void   fires when length === `length`
 *  - length     : expected digit count (default 6)
 *  - disabled   : boolean
 *  - error      : string             shown as error message under input
 *  - autoFocus  : boolean
 *  - ariaLabel  : accessible label
 */
const OTPInput = forwardRef(function OTPInput(
  {
    value = "",
    onChange,
    onComplete,
    length = 6,
    disabled = false,
    error = "",
    autoFocus = false,
    ariaLabel,
  },
  ref
) {
  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, length);
    onChange?.(digits);
    if (digits.length === length) {
      onComplete?.(digits);
    }
  };

  return (
    <div className={`otp-input-wrapper ${error ? "has-error" : ""}`}>
      <input
        ref={ref}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="one-time-code"
        maxLength={length}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        autoFocus={autoFocus}
        className="otp-input"
        dir="ltr"
        aria-label={ariaLabel || `קוד אימות בן ${length} ספרות`}
        data-length={length}
      />
      {error && <span className="otp-input-error">{error}</span>}
    </div>
  );
});

export default OTPInput;
